<template>
  <div class="clinic_wrap">
    <!--左侧患者列表-->
    <div class="patient_list flex0 clinic_left">
      <el-menu default-active="1" :unique-opened="true">
        <!--已候诊-->
        <el-submenu index="1">
          <template slot="title">已候诊({{ signedArr.length }})</template>
          <el-menu-item-group>
            <el-menu-item
                v-for="(p, index) in signedArr"
                :key="p.id"
                index="index"
                style="min-height: 170px"
            >
              <div class="patient_group">
                <div class="patient_group_line">
                  <div class="patient_group_line_l">
                    <span>{{ p.hzxm }}</span>
                    <span>{{ getSex(p.zjhm) }}</span>
                    <span>{{ getAge(p.zjhm) }}岁</span>
                  </div>
                  <span>{{ p.hosPatid }}</span>
                </div>
                <div class="patient_group_line patient_group_line_2">
                  <span class="p_dept">{{ p.ksmc }}-{{ p.ysmc }}</span>
                  <span class="p_num">{{ getAmpm(p.ampm) }}{{ p.numno }}号</span>
                  <span class="p_dept">{{ p.numtime }}</span>
                </div>
                <div class="patient_group_line">
                  <span class="icon-default icon-wait">已准备</span>
                  <div
                      class="patient_group_line_r"
                      style="width: 100%; margin-left: 10px"
                  >
                    <span class="btn" @click="getDetail(p)">查看资料</span>
                    <span class="btn" @click="remindToWait1(p.ddid)">短信提醒</span>
                    <span class="btn" @click="remindToWait(p.ddid)">电话提醒</span>
                    <span class="btn" @click="seeInformation(p.ddid, p.zjhm)">查看信息</span>
                    <span
                        class="btn"
                        @click="remind(p.ddid)"
                        v-if="isShowPatQuery == '1100000020'"
                    >提醒客服</span
                    >
                  </div>
                </div>
                <div class="patient_group_line">
                  <div
                      class="patient_group_line_r"
                      style="margin-left: 50px; margin-top: 10px"
                  >
                    <span class="btn btn_blue" @click="call(p)">视频接诊</span>
                    <span class="btn btn_blue" @click="hangup()">结束通话</span>
                    <span class="btn btn_blue" @click="Prescribing(p)">处方/病历</span>
                    <span class="btn btn_blue" @click="end(p.ddid)">结束订单</span>
                  </div>
                </div>
              </div>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!--已完成-->
        <el-submenu index="3">
          <template slot="title">已完成({{ videoCompleteArr.length }})</template>
          <el-menu-item-group>
            <el-menu-item v-for="p of videoCompleteArr" :key="p.id" :index="p.id">
              <div class="patient_group">
                <div class="patient_group_line">
                  <div class="patient_group_line_l">
                    <span>{{ p.hzxm }}</span>
                    <span>{{ getSex(p.zjhm) }}</span>
                    <span>{{ getAge(p.zjhm) }}岁</span>
                  </div>
                  <span>{{ p.hosPatid }}</span>
                </div>
                <div class="patient_group_line patient_group_line_2">
                  <span class="p_dept">{{ p.deptname }}-{{ p.docname }}</span>
                  <span class="p_num">{{ getAmpm(p.ampm) }}{{ p.numno }}号</span>
                  <span class="p_dept">{{ p.numtime }}</span>
                </div>
                <div class="patient_group_line">
                  <span class="icon-default icon-ywc">已完成</span>
                  <div class="patient_group_line_r">
                    <span class="btn" @click="getDetail(p)">查看资料</span>
                  </div>
                </div>
              </div>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
      <div class="switch-btn" @click="switchDevice">切换摄像头</div>
    </div>

    <!-- 病历提示框 -->
    <el-dialog
        title="病历添加"
        width="70%"
        append-to-body
        :visible.sync="dialogVisible"
        destroy-on-close
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <label style="font-weight: bold; margin-bottom: 20px; display: block"
        >基本信息</label
        >
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名">
              <el-input
                  v-model="userBookCaseHistoryVo.commonPatName"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别">
              <el-input
                  :value="userBookCaseHistoryVo.commonPatSex == 'M' ? '男' : '女'"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年龄">
              <el-input
                  v-model="userBookCaseHistoryVo.commonPatAge"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="婚姻状况" prop="commonPatMarital">
              <el-select
                v-model="ruleForm.commonPatMarital"
                placeholder="请选择婚姻状况"
              >
                <el-option label="未婚" value="0"></el-option>
                <el-option label="已婚" value="1"></el-option>
                <el-option label="离异" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="职业">
              <el-input v-model="ruleForm.commonPatWorker"></el-input>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="科别">
              <el-input
                  v-model="userBookCaseHistoryVo.deptName"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="门诊号">
              <el-input
                  v-model="userBookCaseHistoryVo.clinicNumber"
                  :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <label style="font-weight: bold; margin-bottom: 20px; display: block"
        >疾病信息</label
        >
        <el-row>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="主诉">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入主诉"
                    v-model="userBookCaseHistoryVo.actionInChief"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="病史">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入过敏史"
                    v-model="userBookCaseHistoryVo.diseaseInfo"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="过敏史">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入过敏史"
                    v-model="userBookCaseHistoryVo.drugAllergyHistory"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="辅助检查结果">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入辅助检查结果"
                    v-model="userBookCaseHistoryVo.auxiliaryExamination"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="诊断">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入诊断"
                    v-model="recipeOrderList"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
          <el-col :span="12"
          >
            <div class="grid-content">
              <el-form-item label="处理">
                <el-input
                    type="textarea"
                    :rows="3"
                    placeholder="请输入处理"
                    v-model="recipeOrderInfoList"
                >
                </el-input>
              </el-form-item>
            </div
            >
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12"
            ><div class="grid-content">
              <el-form-item label="所患疾病" prop="diseaseInfo">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入所患疾病"
                  v-model="ruleForm.diseaseInfo"
                >
                </el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="12"
            ><div class="grid-content bg-purple-light">
              <el-form-item label="疾病描述" prop="diseaseDescription">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="请输入疾病描述"
                  v-model="ruleForm.diseaseDescription"
                >
                </el-input>
              </el-form-item></div
          ></el-col>
        </el-row> -->

        <!-- <el-form-item label="现病史" prop="historyPresentIllness">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入现病史"
            v-model="ruleForm.historyPresentIllness"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="既往史" prop="previousHistory">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入既往史"
            v-model="ruleForm.previousHistory"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="家族史" prop="familyHistory">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入家族史"
            v-model="ruleForm.familyHistory"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="阳性体征">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入阳性体征"
            v-model="ruleForm.positiveSign"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="阴性体征">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入阴性体征"
            v-model="ruleForm.negativeSymptoms"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="辅助检查" prop="auxiliaryExamination">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入辅助检查"
            v-model="ruleForm.auxiliaryExamination"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="诊断" prop="diagnose">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入诊断"
            v-model="ruleForm.diagnose"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="治疗意见" prop="treatmentOptions">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入治疗意见"
            v-model="ruleForm.treatmentOptions"
          >
          </el-input>
          <el-button type="primary" size="mini" plain @click="introduce"
            >引入处方信息</el-button
          >
        </el-form-item>
        <el-form-item label="就诊记录" prop="type">
          <el-select v-model="ruleForm.type" placeholder="请选择就诊记录">
            <el-option label="初诊" value="1"></el-option>
            <el-option label="复诊" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="cancel()" style="margin-left: 30px">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="处方信息" width="50%" :visible.sync="Visibledialog" @close="close">
      <el-table
          :data="gridData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          ref="multipleTable"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column property="drugName" label="药品名称"></el-table-column>
        <el-table-column property="frequencyName" label="频次"></el-table-column>
        <el-table-column property="admission" label="用法"></el-table-column>
        <el-table-column property="dosage" label="每次剂量"></el-table-column>
        <el-table-column property="drugSpecification" label="规格"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine">确 定</el-button>
        <el-button @click="cancel1">取 消</el-button>
      </span>
    </el-dialog>
    <!--中间患者资料-->
    <div class="patient_info flex1 clinic_middle flex column" style="overflow: hidden">
      <ImageAmplify/>
      <div class="blank-default" v-show="!detailInfoShow">
        <!--v-show="!detailInfoShow"-->
        <div class="blank-default-content">
        </div>
        <div>请按序选择患者“接诊” 进行网络门诊</div>
      </div>

      <div
          class="patient_info_top flex1"
          style="overflow-y: auto"
          v-show="detailInfoShow"
      >
        <div class="info_content">
          <div class="patient_msg">
            <div class="flex aic" style="height: 40px">
              <span>{{ patientInfo.compatName || ddxx.patname }}</span>
              <span>{{ IDnumber | getSexFromIdCardFilter }}</span>
              <span>{{ IDnumber | getAgeFromIdCardFilter }}</span>
              <span>病案号：{{ ddxx.jzkh || "" }}</span>
            </div>
            <div
                style="height: 40px; justify-content: flex-end; align-items: center"
                class="flex"
            >
              <el-button type="primary" size="mini" @click="showReport"
              >就诊记录
              </el-button
              >
            </div>
          </div>
          <div class="record-content">
            <!-- 患者信息 -->
            <div class="tip_msg">
              以下资料由患者提交，查看院内病历点击
              <span @click="errTip">HIS病历</span>
            </div>
            <div class="record-item">
              <div class="record-item-title">身份证号</div>
              <div class="record-item-content">
                {{ IDnumber ? IDnumber : "空" }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">手机号</div>
              <div class="record-item-content">
                {{ hzxx.sjh ? hzxx.sjh : "空" }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">是否医保患者</div>
              <div class="record-item-content">
                {{ Patientinformation.isMedicinePat }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">险种类型</div>
              <div class="record-item-content">
                {{ Patientinformation.fundtype }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">是否住院</div>
              <div class="record-item-content">
                {{ Patientinformation.hospflag ? Patientinformation.hospflag : "未知" }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">开药需求</div>
              <div class="record-item-content">
                {{
                  Patientinformation.prescribDemand
                      ? Patientinformation.prescribDemand
                      : "空"
                }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">疾病描述</div>
              <div class="record-item-content">
                {{
                  Patientinformation.diseaseDescription
                      ? Patientinformation.diseaseDescription
                      : "空"
                }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">病历/处方图片</div>
              <div class="demo-image__preview" style="margin-top: 5px">
                <el-image
                    v-for="(item, index) in hzxx.medicalHistroyRecipePic"
                    :key="index"
                    style="
                    width: 100px;
                    height: 100px;
                    display: inline-block;
                    margin-left: 10px;
                  "
                    :src="item"
                    :preview-src-list="hzxx.medicalHistroyRecipePic"
                ></el-image>
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">所患疾病</div>
              <div class="record-item-content">
                {{
                  patientInfo.presentingComplaint ? patientInfo.presentingComplaint : "空"
                }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">患者主诉</div>
              <div class="record-item-content">
                {{
                  patientInfo.diseaseDescription ? patientInfo.diseaseDescription : "空"
                }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">既往史</div>
              <div class="record-item-content">
                {{ patientInfo.pastHistory ? patientInfo.pastHistory : "空" }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">家族史</div>
              <div class="record-item-content">
                {{ patientInfo.familyHistory ? patientInfo.familyHistory : "空" }}
              </div>
            </div>
            <div class="record-item">
              <div class="record-item-title">过敏史</div>
              <div class="record-item-content">
                {{ patientInfo.allergyHistory ? patientInfo.allergyHistory : "空" }}
              </div>
            </div>
            <div class="record-img-wrap">
              <img
                  v-for="(item, index) in imgList"
                  class="item-pic record-img w88 h88"
                  :src="item.attaFileUrl"
                  :key="index"
                  @click="scan(index, imgList)"
                  style="margin-left: 10px"
              />
            </div>
            <div class="deal-msg">
              <span class="icon-doc">{{ patientInfo.bookDocName }}</span>
              <div>
                <span> </span>
                <span> </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="patient_info_bottom flex0" v-if="detailInfoShow && isInRoom">
        <div class="operate_content">
          <div class="operate_content_item">
            <span class="icon-operate icon-operate1" @click="showZljl()"></span>
            <span>诊疗记录</span>
          </div>

          <div class="operate_content_item">
            <span class="icon-operate icon-operate3" @click="prescribe()"></span>
            <span>开处方</span>
          </div>
          <div class="operate_content_item">
            <span class="icon-operate icon-operate8" @click="completeClinic"></span>
            <span>结束问诊</span>
          </div>
        </div>
      </div>
    </div>
    <!--右侧视频-->
    <div class="video_box flex0 clinic_right" id="video_box" v-if="isCalling">
      <!--      <Videocall-->
      <!--        v-if="showcom"-->
      <!--        :toAccount="toAccount"-->
      <!--        :patient="patient"-->
      <!--        @close="VideoClose"-->
      <!--      ></Videocall>-->
      <div class="minimized-box" v-show="isCalling && isMinimized">
        最小化模式
      </div>

<!-- 视频通话组件 -->
        <TUICallKit
            :beforeCalling="beforeCalling"
            :afterCalling="afterCalling"
            :onMinimized="onMinimized"
            :allowedMinimized="false"
            :allowedFullScreen="true"
            :videoDisplayMode="VideoDisplayMode.CONTAIN"
            :videoResolution="VideoResolution.RESOLUTION_480P"
            @kicked-out="handleKickedOut"
            @status-changed="handleStatusChanged"
        />
<!--      <TUICallKitMini/>-->
<!-- 视频通话组件 -->
    </div>
    <el-dialog
        title="请将以下地址复制给要会诊的医生"
        :append-to-body="true"
        :visible.sync="shareDialog"
        width="80%"
    >
      <el-input placeholder="请输入内容" v-model="link">
        <template slot="append">
          <span
              class="pointer"
              v-clipboard:copy="link"
              v-clipboard:success="() => $message.success('复制成功')"
          >复制</span
          >
        </template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shareDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 线上线下就诊记录的组件 -->
    <wlmz-online-report
        ref="report"
        :lineList="lineList"
        :onLineList="onLineList"
        :totalList="totalList"
    ></wlmz-online-report>
    <wlmz-jzjl-make ref="jzjl"></wlmz-jzjl-make>
    <PicScan ref="scan"></PicScan>
  </div>
</template>

<script>
import {
  TUICallKit,
  TUICallKitServer,
  // TUICallKitMini,
  TUICallType,
  VideoDisplayMode,
  VideoResolution,
} from "@tencentcloud/call-uikit-vue2";

import { TUICallEvent} from "tuicall-engine-webrtc";

import axiosUtil from "../../utils/AxiosUtils.js";
import {Message, MessageBox} from "element-ui";
import ImageAmplify from "../common/ImageAmplify.vue";
import PicScan from "../common/pic-scan";
// import fileClassification from "../../utils/FileClassificationUtils.js";
import {timeStampFormat} from "../../utils/DateFormat.js";
// import { leaveRoom } from "../../utils/3tee-video";
// import { closeAudio, closeVideo, openAudio, openVideo } from "../../utils/tencent-video";
import {tokenCache} from "../../../cache/tokenCache";
import {getAgeFromIdCardFilter, getSexFromIdCardFilter} from "../../lib/filters";
// import WlmzVideo from "./wlmz-video";
import WlmzOnlineReport from "./wlmz-online-report.vue";
import WlmzJzjlMake from "./wlmz-jzjl-make.vue";
import {imageAmplify} from "../../utils/ImageAmplify.js";
import {OnlineMixin} from "../../lib/queryOnlineMixin";

export default {
  props: ["propsTableData", "isGetData"],
  data() {
    return {
      userID: "",
      userSig: "", //视频初始化签名
      VideoDisplayMode,
      VideoResolution,
      isCalling: false,
      isMinimized: false,
      hzobj: {},
      shareDialog: false,
      isShowPatQuery: JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId,
      link: "",
      docInfo: {},
      clinicType: "doc",
      typeList: [
        {
          name: "专家门诊",
          value: "doc",
        },
        {
          name: "科室门诊",
          value: "dep",
        },
      ],
      gridData: [],
      multipleSelection: [],
      patient: {},
      Patientinformation: {}, //患者信息
      deptId: "",
      deptList: [],
      detailInfoShow: false,
      isPatientVideo: true,
      isShirinkP: false,
      isShirinkS: false,
      initRTCok: false, //视频初始化是否成功
      roomNo: "", //房间号
      showVoice: true, //是否静音
      showVideo: true, //是否有开启摄像头
      isInRoom: false, //是否已经进入诊间
      isReEnterRoom: false, //是否重新进入诊间
      patientInfo: {},
      Visibledialog: false,
      ddId: "",
      queryReady: false,
      imgList: [], //附件图片列表
      fileList: [], //附件文件列表
      IDnumber: "",
      // showcom: false,
      toAccount: '',
      dialogVisible: false, //病历提示框
      ruleForm: {
        bookOrderNumber: "",
        bookId: "",
        bookNum: "",
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        commonPatId: "",
        name: "",
        card: "",
        deptName: "", //科别
        commonPatSex: "", //男女
        commonPatWorker: "", //职业
        commonPatCompany: "", //工作单位
        commonPatAddress: "", //住址
        commonPatMarital: "", //婚姻状况
        diseaseInfo: "", //所患疾病
        diseaseDescription: "", //疾病描述
        drugAllergyHistory: "", //过敏史
        actionInChief: "", //主诉
        historyPresentIllness: "", //现病史
        previousHistory: "", //既往史
        familyHistory: "", //家族史
        positiveSign: "", //阳性体征
        negativeSymptoms: "", //阴性体征
        auxiliaryExamination: "", //辅助检查
        diagnose: "", //诊断
        treatmentOptions: "", //治疗意见
        type: "", //就诊记录
        visitTime: "",
      },
      rules: {
        commonPatMarital: [
          {required: true, message: "请选择婚姻状况", trigger: "change"},
        ],
        commonPatCompany: [
          {required: true, message: "请输入工作单位", trigger: "blur"},
        ],
        commonPatAddress: [{required: true, message: "请输入住址", trigger: "blur"}],
        diseaseInfo: [{required: true, message: "请输入所患疾病", trigger: "blur"}],
        diseaseDescription: [
          {required: true, message: "请输入疾病描述", trigger: "blur"},
        ],
        drugAllergyHistory: [
          {required: true, message: "请输入过敏史", trigger: "blur"},
        ],
        actionInChief: [{required: true, message: "请输入主诉", trigger: "blur"}],
        historyPresentIllness: [
          {required: true, message: "请输入现病史", trigger: "blur"},
        ],
        previousHistory: [{required: true, message: "请输入既往史", trigger: "blur"}],
        familyHistory: [{required: true, message: "请输入家族史", trigger: "blur"}],
        auxiliaryExamination: [
          {required: true, message: "请输入辅助检查", trigger: "blur"},
        ],
        diagnose: [{required: true, message: "请输入诊断", trigger: "blur"}],
        treatmentOptions: [
          {required: true, message: "请输入治疗意见", trigger: "blur"},
        ],
        type: [{required: true, message: "请选择就诊记录", trigger: "change"}],
      },
      //医生签名
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      isCrop: false,
      userBookCaseHistoryVo: {},
      recipeOrderInfoList: "",
      recipeOrderList: "",
      hzxx: {},
      avatar: "https://ayh.yhfhyy.com.cn/img/doc_active.jpg",
      callUserId:'',//被呼叫者id
      mixSteamimg: false,
      devicesNumber:0,
      hosId:'',//当前登录人的hosid,
      isRequestNewMixInterface: '0',
      taskId: ''
    };
  },
  filters: {getAgeFromIdCardFilter, getSexFromIdCardFilter},
  mixins: [OnlineMixin],
  components: {
    ImageAmplify,
    PicScan,
    WlmzOnlineReport,
    WlmzJzjlMake,
    TUICallKit
  },
  created() {
    this.getDeptList();
  },
  mounted() {
    // 加载main加载main加载main加载main加
    if(!this.tuiCallEngine) {
      console.log(`==注册监听====!this.tuiCallEngine====!!!===>`,)
      //2024.07.23 修改, 之前请求频率太高 导致无限刷新
      setTimeout(() => {
        window.location.reload();
      }, 1000)
    }else{
      //注册监听
      console.log(`==注册监听注册监听注册监听==this.tuiCallEngine=========>`, this.tuiCallEngine)
      // bus.$on("joinSuccess", this.joinSuccess);
      // bus.$on("onUserJoinNotify", this.onUserJoinNotify);
      this.tuiCallEngine.on(TUICallEvent.ON_CALL_BEGIN, this.handleOnCallBegin);
      this.tuiCallEngine.on(TUICallEvent.CALLING_END, this.handleCallingEnd);
      this.initBefor()
    }
  },

  beforeDestroy() {
    console.log(`====取消监听取消监听取消监听取消监听取消监听=========>`,)
    // bus.$off("joinSuccess");
    // bus.$off("onUserJoinNotify");

    //取消监听
    this.tuiCallEngine.off(TUICallEvent.ON_CALL_BEGIN, this.handleOnCallBeginOff, this);
    this.tuiCallEngine.off(TUICallEvent.CALLING_END, this.handleCallingEndEndOff, this);
  },
  computed: {
    commonPatSex: {
      get() {
        return 1;
      },
      set(val) {
        return 2;
      },
    },
    ddxx() {
      const {patientInfo} = this;
      if (patientInfo.ddxx && patientInfo.ddxx.code === "0") {
        return patientInfo.ddxx.obj;
      }
      return {};
    },
    isEnter() {
      console.log("进入视频的患者id",this.$store.state.enterVideopatientId)
      //进入视频的患者id
      return this.$store.state.enterVideopatientId;
    },
    signedArr() {
      //已候诊
      let sArr = [];
      for (let i = 0; i < this.propsTableData.length; i++) {
        if (this.propsTableData[i].ddzt == "9") {
          // if(this.propsTableData[i].ddzt=="6"){
          sArr.push(this.propsTableData[i]);
        }
      }
      return sArr;
    },
    // waitVideoArr() {
    //   //未就诊
    //   let wArr = [];
    //   for (let i = 0; i < this.propsTableData.length; i++) {
    //     if (this.propsTableData[i].ddzt == "3") {
    //       wArr.push(this.propsTableData[i]);
    //     }
    //   }
    //   return wArr;
    // },
    videoCompleteArr() {
      //已完成
      let vArr = [];
      for (let i = 0; i < this.propsTableData.length; i++) {
        if (this.propsTableData[i].ddzt == "2") {
          vArr.push(this.propsTableData[i]);
        }
      }
      return vArr;
    },
    enterVideoList() {
      return this.$store.state.enterVideoList;
    },
  },
  methods: {

     async handleOnCallBegin(event) {
       let _this = this
       console.log(`===进入诊间==回调==start==获取标识====>`)
       //直接取用session中保存的isRequestNewMixInterface 2023.11.15
       // // 2023.10.30
       // //获取标识
       // let {code, obj} = await _this.$http(
       //     "smarthos.tencent.imo.config.by.hosid",
       //     {hosId: _this.hosId}
       // );
       // console.log(`=====获取标识===isRequestNewMixInterfaceisRequestNewMixInterface=====>`,code, obj)
       // _this.isRequestNewMixInterface=obj.isRequestNewMixInterface

       if (!this.mixSteamimg) {
         this.mixSteamimg = true
         let options = {
           id: _this.patient.ddid,
           token: localStorage.getItem("token"),
           businessType: "BJJSHOS_DOC_OPEN_VIDEO_REMIND_TEMPLATE",
           pageMini: "pages/index/index",
         };
         let joinRoomRes = await _this.$http(
             "smarthos.online.outpatient.intovideo",
             options
         );
         console.log(`===进入诊间==回调==end======>`, joinRoomRes)

         //患者开始通话
         //调用混流
         console.log(`========调起混流==event===>`, event)
         let isRequestNewMixInterface = window.sessionStorage.getItem("isRequestNewMixInterface")
         console.log(`=======isRequestNewMixInterface======>`, isRequestNewMixInterface)
         if (isRequestNewMixInterface == 0) {
           console.log(`=====_this.isRequestNewMixInterface_this.isRequestNewMixInterface_this.===1=====>`, _this.isRequestNewMixInterface)
           await _this.Mixedflow(event)
         } else {
           //新账号走新混流接口 2023.10.30
           console.log(`=====_this.isRequestNewMixInterface_this.isRequestNewMixInterface_this.===2=====>`, _this.isRequestNewMixInterface)
           await _this.MixedflowNew(event)
         }
         this.mixSteamimg = false
       } else {
         console.log(`====忽略混流多次回调====忽略=====>`,)
       }
     },

    //升级时实音视频- 混流
    Mixedflow(e) {
      console.log(`======旧接口 Mixedflow=======>`,)
      let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));

      let _this = this;
      let options = {
        token: localStorage.getItem("token"),
        streamId: _this.patient.ddid,
        roomId: e.roomID,
        sdkAppId: Number(window.sessionStorage.getItem("videoAppId")),
        businessType: "ONLINE_OUTPATIENT",
        tencentUserId: _this.callUserId,
        tencentDocId: loginInfo?.doc?.id,
        service: "smarthos.tencent.video.start.mcumix.trans.info",
      };
      axiosUtil(options, function (data) {
        console.log(`=====Mixedflow===混流=====>`,data)
      });
    },

   async MixedflowNew(e) {
      console.log(`======新接口 MixedflowNew=======>`,)
     let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
      let _this = this;
      let options = {
        token: localStorage.getItem("token"),
        streamId: _this.patient.ddid,
        roomId: e.roomID,
        sdkAppId: Number(window.sessionStorage.getItem("videoAppId")),
        businessType: "ONLINE_OUTPATIENT",
        tencentUserId: _this.callUserId,
        tencentDocId: loginInfo?.doc?.id,
        hosId: _this.patient.yyid,
        service: "smarthos.tencent.video.start.mcumix.trans.info.new",
      };
      console.log(`==========111111111111111111新混流接口11111111111111111111111111===>`,)
      // axiosUtil(options, function (data) {
      //   console.log(`=====MixedflowNew===混流===taskId==>`,data)
      //   _this.taskId=data.obj.taskId
      //   console.log(`==========33333333333333333333333333333333333333333===>`,)
      // });

      let {code, obj} = await _this.$http(
          "smarthos.tencent.video.start.mcumix.trans.info.new",
          options
      );

      console.log(`==========2222222222222222222222222222222===>`,code, obj)
     _this.taskId=obj.taskId
     console.log(`==========2222222222222222222222222222222==获取obj.taskId=>`,obj.taskId)
    },

    handleCallingEnd(event){
        console.log("================2222222222222222222222===================挂电话===========>handleCallingEnd",event);
      // this.tuiCallEngine.hangup().then((e) => {
      //   // success
      //   console.log("=",e)
      // }).catch(error => {
      //   console.warn('hangup error:', error);
      // });
      let options={
        taskId: this.taskId,
        hosId: this.patient.yyid,
        service: "smarthos.tencent.video.end.mcumix.trans.info.new",
      }
      axiosUtil(options, function (data) {
        console.log(`===挂电话==Mixedflow===混流结束=====>`,data)
      });
    },

    handleOnCallBeginOff(e){
      console.log(`=======销毁==handleOnCallBeginOff====>`,e)
    },
    handleCallingEndEndOff(e){
      console.log(`=======销毁==handleCallingEndEndOff====>`,e)
    },

    //初始化医生及签名, 必须在init之前
    async initBefor() {
      let _this=this
      if (localStorage.getItem("token")) {
        let DocId=JSON.parse(sessionStorage.getItem("loginInfo")).doc.id
        let loginInfo = JSON.parse(sessionStorage.getItem("loginInfo"));
        _this.hosId=loginInfo.doc.hosId
        let options = {
          // service: "smarthos.tencent.imo.generate.user.sig",
          service: "smarthos.tencent.imo.generate.user.sig.not.catch",
          hosId: loginInfo.doc.hosId,
          userType: "DOC",
          userId: DocId,
          token: localStorage.getItem("token"),
        };
        console.log(`=======切换接口2023.10.26======>`,options)
        new Promise((resolve, reject) => {
            axiosUtil(options, async function (data) {
                console.log(`===切换接口2023.10.26===请求返回========>`,data)
                try{
                  if (data.code == "0") {
                    let userInfo={
                      userID: DocId, userSig: data.obj.userSig
                    }
                    sessionStorage.setItem('TuiCallkitUserInfo', JSON.stringify(userInfo))
                    // 登录tuiCallEngine
                   // await _this.tuiCallEngine.login({userID: DocId, userSig: data.obj.userSig});
                    console.log("医生签名成功,TuiCallkitUserInfo数据已保存", data);
                    resolve(userInfo);
                  } else {
                    console.log(`=====模拟延时===请求失败=====>`,data)
                    reject(data);
                  }
                } catch (e) {
                  reject(e);
                }
              });
        }).then(res => {
          console.log(`==then=开始调 init=签名成功后res的数据========>`,res)
          //开始调 init
          let user = JSON.parse(sessionStorage.getItem("loginInfo"));
          if(user){
            _this.init(res, user)
          }else {
            console.log(`======用户信息不存在,初始化失败=======>`,)
            alert("用户信息不存在,初始化失败")
            return
          }
        }).catch((e) => {
          console.log(`========出错了=====>`,e)
        });
      } else {
        console.log("main.js===> 未找到token");
        this.$router.push('/login')
      }
    },

    //升级实时音视频-start
    async init(userInfo, user) {
      console.log(`======开始调用 init=======>`,userInfo)
      if(userInfo.userID) {
        try {
          let signObj = {
            SDKAppID: Number(window.sessionStorage.getItem("videoAppId")),
            userID: userInfo.userID,//医生id
            userSig: userInfo.userSig,
            // tim: this.tim
          }
          console.log(`=====signObj========>`, signObj)
          await TUICallKitServer.init(signObj);
          let nickName = user.doc.deptName + "-" + user.doc.docName
          let userObj = {nickName, avatar: user.doc.docAvatar ? user.doc.docAvatar : this.avatar}
          console.log(`=====userObj========>`, userObj)
          await TUICallKitServer.setSelfInfo(userObj);
          this.$message.success('实时音视频初始化成功')
          console.log("实时音视频初始化完成");
        } catch (error) {
          alert(`实时音视频初始化失败，原因：${error}`);
        }
      }else{
        alert(`实时音视频初始化失败2，原因：`+ JSON.stringify(userInfo));
      }
    },
    
    //拨打视频电话
    async call(patient) {
      let _this = this

      if (_this.isCalling) {
        _this.$message.error("忙线中, 请先结束当前通话")
        return
      }

      MessageBox.confirm("是否确认接诊患者？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async (res) => {
        try {
          //开始通话,当前患者id为
          console.log("开始通话patient", patient)
          _this.patient = patient

          //判断是否为代挂号
          //isAssAppointment 1表示医助代挂号  appointmentUserId 代挂号人的编号
          let callUserId = patient.isAssAppointment == 1 ? patient.appointmentUserId : patient.hzid;
          _this.callUserId = callUserId
          console.log("=================callUserId已赋值 患者id", callUserId)

          //更新患者信息
          await  _this.updaePatInfoOfTencent(callUserId, patient.hzxm)
          console.log(`====updaePatInfoOfTencent===更新患者信息===结果===>`,)

          // 1v1 通话
          await TUICallKitServer.call({
            userID: callUserId, //patient.ddid //患者id
            type: TUICallType.VIDEO_CALL,
          })
          _this.isCalling = true;
          // 群组通话
          // TUICallKitServer.groupCall({ userIDList: ["xxx"], groupID: "xxx", type: TUICallType.VIDEO_CALL });
        } catch (error) {
          _this.callUserId = ''
          alert(`拨打失败，原因：${error}`);
        }
      })
    },

    async hangup() {
      try {
        await TUICallKitServer.hangup();
        this.callUserId=''
        this.$message.success('主动挂断成功')
      } catch (error) {
        this.$message.error('主动挂断失败')
        console.log(`主动挂断失败，原因：${error}`);
      }
    },

    /**
     * 更新腾讯云用户信息
     * 2024.07.23
     * sdkappid //需要动态获取
     */
  async updaePatInfoOfTencent(userId, username) {
      let _this = this
      let SDKAppID=this.SDKAppID
      console.log(`===updaePatInfoOfTencent====SDKAppID======>`,SDKAppID)
      let randomNum = Math.floor(Math.random() * (4294967296))
      let adminUserSign = await _this.getUserSig()
      let reqUrl = "?sdkappid=" + SDKAppID + "&identifier=administrator&usersig=" + adminUserSign + "&random=" + randomNum + "&contenttype=json"

      //要更新的患者信息
      let payload = {
        "UserID": userId,
        "Nick": username,
        // "FaceUrl": _this.baseUrl + '/img/defaulthead.png'
      }
      await axios({
        url: 'https://console.tim.qq.com/v4/im_open_login_svc/account_import' + reqUrl,
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }).then(res => {
        console.log(`更新腾讯云用户信息成功===>`, res)
      }).catch(err => {
        console.log(`更新腾讯云用户信息失败===>`, err)
      })
    },

    getUserSig() {
      //保证用户登录成功后初始化 //fleet 2023年7月25日
      return new Promise((resolve, reject) => {
        let options = {
          service: "smarthos.tencent.imo.generate.user.sig.not.catch",
          userType: "PAT",
          userId: "administrator",//固定用户, 需要有管理员权限
          token: localStorage.getItem("token"),
        };

        axiosUtil(options, (data) => {
          console.log(`===切换接口2024.07.23===请求返回========>`, data)
          try {
            if (data.code == "0") {
              resolve(data.obj.userSig);
            } else {
              reject("");
            }
          } catch (e) {
            reject("");
          }
        })
      })
    },

    //fleet 切换摄像头
    switchDevice() {
      this.tuiCallEngine.getDeviceList('camera').then((devices) => {  // 获取摄像头列表
        console.log("设备列表===>", devices)
        if (devices.length > 1) {
          let currNum = this.devicesNumber === 0 ? 1 : 0
          let promise = this.tuiCallEngine.switchDevice({deviceType: 'video', deviceId: devices[currNum].deviceId}) // 切换设备
          promise.then(() => {
            this.$message.success('切换成功')
          }).catch(error => {
            console.warn('切换错误switchDevice error:', error)
          });
        }else{
          this.$message.success('只有一个摄像头,无需切换')
        }
      }).catch(error => {
        console.warn('getDeviceList error:', error)
        if(error.code=== -1101){
          this.$message.error('权限不足')
        }
      });
    },

    beforeCalling(type, error) {
      console.log("通话即将开始=======beforeCalling==========", type, error);
    },
    afterCalling(e) {
      this.isCalling=false
      this.callUserId=''
      console.log("通话已结束======afterCalling=======",e);
    },
    onMinimized(oldStatus, newStatus) {
      console.log("最小化状态变更: " + oldStatus + " -> " + newStatus);
      this.isMinimized = newStatus;
    },
    handleKickedOut(e) {
      console.error("=======handleKickedOut==========The user has been kicked out",e);
    },
    handleStatusChanged(args) {
      const {oldStatus, newStatus} = args;
      console.log("通话状态变更: " + oldStatus + " -> " + newStatus, args);
    },

    async seeInformation(id, zjhm) {
      this.IDnumber = zjhm;
      // let data = await this.$http("smarthos.online.outpatient.pack.info",{id:"10000855"});
      let data = await this.$http("smarthos.online.outpatient.pack.info", {
        id: id,
      });
      //let data = await this.$http("smarthos.yygh.ApiDoctorService.orderByDdid", {ddid: id});
      this.patientInfo = data.obj;
      this.hzxx = data.obj.ddxx.obj;
      this.hzxx.medicalHistroyRecipePic = this.hzxx.medicalHistroyRecipePic.split(",");
      this.fileList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
      this.imgList = []; //清空内容，否则使用路由跳转页面不重载时，可能会多个单子的附件一起push进来
      // fileClassification(data.obj.attaList, this.imgList, this.fileList);
      //查询线上 和 线下就诊记录
      // this.totalList = [];
      // this.$refs["report"].reset();
      // await this.queryLineOrder(this.ddxx);
      // await this.queryOnLineOrder(this.ddxx);
      this.detailInfoShow = true;
      // let obj = await this.$http(
      //   "smarthos.yygh.ApiyGHpaymentService.orderPayment.get",
      //   {
      //     id: id,
      //   }
      // );
      // this.Patientinformation = obj.obj;
      // if (this.Patientinformation.hospflag == "1") {
      //   this.Patientinformation.fundtype = "住院中";
      // } else if (this.Patientinformation.hospflag == "2") {
      //   this.Patientinformation.fundtype = "未住院";
      // } else {
      //   this.Patientinformation.fundtype = "未知";
      // }
      // if (this.Patientinformation.fundtype == "1") {
      //   this.Patientinformation.fundtype = "基本养老保险";
      // } else if (this.Patientinformation.fundtype == "2") {
      //   this.Patientinformation.fundtype = "失业保险";
      // } else if (this.Patientinformation.fundtype == "20") {
      //   this.Patientinformation.fundtype = "大额医疗互助";
      // } else if (this.Patientinformation.fundtype == "3") {
      //   this.Patientinformation.fundtype = "基本医疗保险";
      // } else if (this.Patientinformation.fundtype == "30") {
      //   this.Patientinformation.fundtype = "公务员医疗互助";
      // } else if (this.Patientinformation.fundtype == "31") {
      //   this.Patientinformation.fundtype = "离休医疗费统筹";
      // } else if (this.Patientinformation.fundtype == "32") {
      //   this.Patientinformation.fundtype = "公费医疗";
      // } else if (this.Patientinformation.fundtype == "33") {
      //   this.Patientinformation.fundtype = "征地超转人员医疗保险";
      // } else if (this.Patientinformation.fundtype == "4") {
      //   this.Patientinformation.fundtype = "工伤保险";
      // } else if (this.Patientinformation.fundtype == "5") {
      //   this.Patientinformation.fundtype = "生育";
      // } else if (this.Patientinformation.fundtype == "6") {
      //   this.Patientinformation.fundtype = "企业补充养老保险";
      // } else if (this.Patientinformation.fundtype == "7") {
      //   this.Patientinformation.fundtype = "个人储蓄性养老保险";
      // } else if (this.Patientinformation.fundtype == "8") {
      //   this.Patientinformation.fundtype = "补充医疗保险";
      // } else if (this.Patientinformation.fundtype == "81") {
      //   this.Patientinformation.fundtype = "退休人员统一补充医疗保险";
      // } else if (this.Patientinformation.fundtype == "91") {
      //   this.Patientinformation.fundtype = "学生儿童大病医疗保险";
      // } else if (this.Patientinformation.fundtype == "92") {
      //   this.Patientinformation.fundtype = "城镇无保障老年人大病医疗保险";
      // } else if (this.Patientinformation.fundtype == "93") {
      //   this.Patientinformation.fundtype = "城镇居民基本医疗保险";
      // } else {
      //   this.Patientinformation.fundtype = "未知";
      // }
      // if (this.Patientinformation.isMedicinePat == "1") {
      //   this.Patientinformation.isMedicinePat = "是";
      // } else {
      //   this.Patientinformation.isMedicinePat = "未知";
      // }

      // this.Patientinformation.medicalHistroyRecipePic = this.Patientinformation.medicalHistroyRecipePic.split(
      //   ","
      // );
    },
    close() {
      this.Visibledialog = false;
      this.gridData = [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    determine() {
      let str = "";
      for (let i in this.multipleSelection) {
        str +=
            this.multipleSelection[i].drugName +
            " " +
            this.multipleSelection[i].drugSpecification +
            " 用法用量" +
            this.multipleSelection[i].admission +
            "," +
            this.multipleSelection[i].frequencyName +
            ",每次" +
            this.multipleSelection[i].dosage +
            this.multipleSelection[i].dosageUnit +
            " ";
      }
      this.ruleForm.treatmentOptions = str;
      this.gridData = [];
      this.Visibledialog = false;
    },
    cancel1() {
      this.Visibledialog = false;
      this.gridData = [];
    },
    introduce() {
      this.initdialogData();
      this.Visibledialog = true;
    },
    initdialogData() {
      let that = this;
      axiosUtil(
          {
            service: "smarthos.book.pat.recipe.order.info.list",
            compatId: that.ruleForm.commonPatId,
            bizId: that.ruleForm.bookId,
          },
          ({code, list, msg}) => {
            if (code == "0") {
              for (let i in list) {
                this.gridData.push(list[i]);
              }
            }
          }
      );
    },
    Prescribing(obj) {
      window.localStorage.setItem("userobj", JSON.stringify(obj));
      this.$router.push({path: "/main/Report"});
    },
    medicalRecord(p) {
      this.ruleForm.bookId = p.ddid;
      this.ruleForm.bookNum = p.numno;
      this.ruleForm.bookOrderNumber = p.bookOrderNumber;
      this.ruleForm.visitTime = p.ghrq + " " + p.czsj;
      this.ruleForm.commonPatId = p.visitid;
      this.ruleForm.name = p.hzxm;
      this.ruleForm.card = p.zjhm;
      this.initData(p);
      this.dialogVisible = true;
    },
    initData(p) {
      let that = this;

      axiosUtil(
          {
            service: "smarthos.user.book.case.history.max.create.time.record",
            commonPatId: p.visitid,
            token: localStorage.getItem("token"),
            bookId: that.ruleForm.bookId,
            bookOrderNumber: that.ruleForm.bookOrderNumber,
          },
          ({code, obj, msg}) => {
            if (code == "0") {
              that.recipeOrderInfoList = obj.recipeOrderInfoList;
              let str = "";
              for (let i in obj.recipeOrderList) {
                str += obj.recipeOrderList[i].allergyHistory + ";";
              }
              that.recipeOrderList = str;
              let str1 = "";
              for (let i in obj.recipeOrderInfoList) {
                str1 +=
                    obj.recipeOrderInfoList[i].drugName +
                    " " +
                    obj.recipeOrderInfoList[i].drugSpecification +
                    " " +
                    "用法 " +
                    obj.recipeOrderInfoList[i].admission +
                    " " +
                    obj.recipeOrderInfoList[i].frequencyName +
                    " " +
                    "每次" +
                    obj.recipeOrderInfoList[i].dosage +
                    obj.recipeOrderInfoList[i].dosageUnit;
              }
              that.recipeOrderInfoList = str1;
              that.userBookCaseHistoryVo = obj.userBookCaseHistoryVo;
              that.userBookCaseHistoryVo.commonPatAge = that.getAge(
                  that.userBookCaseHistoryVo.commonPatIdcard
              );
              that.userBookCaseHistoryVo.clinicNumber = p.hosPatid;
              // // that.ruleForm.docId = obj.docId;
              // that.ruleForm.commonPatId = obj.commonPatId;
              // that.ruleForm.deptName = obj.deptName;
              // that.ruleForm.commonPatSex = obj.commonPatSex;
              // that.ruleForm.commonPatWorker = obj.commonPatWorker;
              // that.ruleForm.commonPatCompany = obj.commonPatCompany;
              // that.ruleForm.commonPatAddress = obj.commonPatAddress;
              // that.ruleForm.commonPatMarital = obj.commonPatMarital;
              // that.ruleForm.diseaseInfo = obj.diseaseInfo;
              // that.ruleForm.diseaseDescription = obj.diseaseDescription;
              // that.ruleForm.drugAllergyHistory = obj.drugAllergyHistory;
              // that.ruleForm.actionInChief = obj.actionInChief;
              // that.ruleForm.historyPresentIllness = obj.historyPresentIllness;
              // that.ruleForm.previousHistory = obj.previousHistory;
              // that.ruleForm.familyHistory = obj.familyHistory;
              // that.ruleForm.positiveSign = obj.positiveSign;
              // that.ruleForm.negativeSymptoms = obj.negativeSymptoms;
              // that.ruleForm.auxiliaryExamination = obj.auxiliaryExamination;
              // that.ruleForm.diagnose = obj.diagnose;
              // that.ruleForm.treatmentOptions = obj.treatmentOptions;
              // that.ruleForm.type = obj.type;
            }
          }
      );
    },
    submitForm(formName) {
      let that = this;
      axiosUtil(
          {
            service: "smarthos.user.book.case.history.save.update.new",
            bookId: that.ruleForm.bookId,
            bookOrderNumber: that.ruleForm.bookOrderNumber,
            visitTime: that.ruleForm.visitTime,
            bookNum: that.ruleForm.bookNum,
            docId: that.ruleForm.docId,
            commonPatId: that.ruleForm.commonPatId,
            auxiliaryExamination: that.userBookCaseHistoryVo.auxiliaryExamination,
            drugAllergyHistory: that.userBookCaseHistoryVo.drugAllergyHistory,
            diseaseInfo: that.userBookCaseHistoryVo.diseaseInfo,
            actionInChief: that.userBookCaseHistoryVo.actionInChief,
            diagnose: that.recipeOrderList,
            treatmentOptions: that.recipeOrderInfoList,
            clinicNumber: that.userBookCaseHistoryVo.clinicNumber,
            token: localStorage.getItem("token"),
          },
          ({code, obj, msg}) => {
            if (code == "0") {
              that.$message({
                type: "success",
                message: "保存成功!",
              });
              that.cancel();
            }
          }
      );
    },
    cancel() {
      this.ruleForm.bookOrderNumber = "";
      this.ruleForm.bookId = "";
      this.ruleForm.bookNum = "";
      this.ruleForm.docId = "";
      this.ruleForm.commonPatId = "";
      this.ruleForm.name = "";
      this.ruleForm.card = "";
      this.ruleForm.commonPatWorker = ""; //职业
      this.ruleForm.commonPatCompany = ""; //工作单位
      this.ruleForm.commonPatAddress = ""; //住址
      this.ruleForm.commonPatMarital = ""; //婚姻状况
      this.ruleForm.diseaseInfo = ""; //所患疾病
      this.ruleForm.diseaseDescription = ""; //疾病描述
      this.ruleForm.drugAllergyHistory = ""; //过敏史
      this.ruleForm.actionInChief = ""; //主诉
      this.ruleForm.historyPresentIllness = ""; //现病史
      this.ruleForm.previousHistory = ""; //既往史
      this.ruleForm.familyHistory = ""; //家族史
      this.ruleForm.positiveSign = ""; //阳性体征
      this.ruleForm.negativeSymptoms = ""; //阴性体征
      this.ruleForm.auxiliaryExamination = ""; //辅助检查
      this.ruleForm.diagnose = ""; //诊断
      this.ruleForm.treatmentOptions = ""; //治疗意见
      this.ruleForm.type = ""; //就诊记录
      this.ruleForm.visitTime = "";
      this.dialogVisible = false;
      this.resultImg = "";
    },
    end(ddid) {
      //结束订单
      let _this = this;
      _this
          .$confirm("确认是否结束此订单?", "提示", {
            confirmButtonText: "确定结束",
            cancelButtonText: "暂不结束",
            type: "warning",
          })
          .then(async () => {
            let options = {
              id: ddid,
              token: localStorage.getItem("token"),
            };
            let {code, obj} = await _this.$http(
                "smarthos.online.outpatient.complete",
                options
            );
            if (code == 0) {
              Message({
                showClose: true,
                message: "门诊已结束",
                type: "success",
              });
              _this.$router.go(0);
            }
          })
          .catch(() => {
            Message({
              showClose: true,
              message: "订单结束失败,请重试",
              type: "error",
            });
          });
    },
    // VideoClose() {
    //   this.showcom = false;
    // },
    scan(index = 0, attr = []) {
      let list = [];
      attr.forEach((r) => {
        list.push(r.attaFileUrl);
      });
      this.$refs.scan.show(index, list);
    },
    //显示就诊记录
    async showReport() {
      this.$refs["report"].show();
    },
    async getDeptList() {
      let {code, list} = await this.$http(
          "smarthos.yygh.ApiDepartmentService.selectYyksListByBzksId",
          {
            hosid: "057301",
          }
      );
      code == "0" && (this.deptList = list);
    },
    // entryVideo1() {
    //   const tim1 = this.TIM.create({
    //     SDKAppID: this.SDKAppID,
    //   });
    //   let _this = this;
    //   let options = {
    //     service: "smarthos.tencent.imo.generate.user.sig",
    //     hosId: "1100000001",
    //     userType: "DOC",
    //     userId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //     token: localStorage.getItem("token"),
    //   };
    //   axiosUtil(options, function (data) {
    //     if (data.code == "0") {
    //       let userSig = data.obj.userSig;
    //       let promise = tim1.login({
    //         userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //         userSig: userSig,
    //       });
    //       promise
    //         .then(function (imResponse) {
    //           let IM_userInfo = {
    //             userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //             userSig: userSig,
    //           };
    //           localStorage.setItem("IM_userInfo", JSON.stringify(IM_userInfo));
    //           let userID = JSON.parse(sessionStorage.getItem("loginInfo")).doc.id;
    //           _this.trtcCalling.login({ userID, userSig });
    //           _this.showcom = false;
    //           _this.$nextTick(() => {
    //             _this.toAccount = "662288714752";
    //             _this.showcom = true;
    //           });
    //         })
    //         .catch(function (imError) {
    //           console.warn("login error:", imError); // 登录失败的相关信息
    //         });
    //     }
    //   });
    //   tim1.setLogLevel(1);
    // },
    // entryVideo(p) {
    //   if (this.showcom) {
    //     Message({
    //       showClose: true,
    //       message: "请先结束当前通话后再发起视频",
    //       type: "error",
    //     });
    //     return;
    //   }
    //   const tim1 = this.TIM.create({
    //     SDKAppID: this.SDKAppID,
    //   });
    //   let _this = this;
    //   let options = {
    //     service: "smarthos.tencent.imo.generate.user.sig",
    //     hosId: "1100000001",
    //     userType: "DOC",
    //     userId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //     token: localStorage.getItem("token"),
    //   };
    //   axiosUtil(options, function (data) {
    //     if (data.code == "0") {
    //       let userSig = data.obj.userSig;
    //       let promise = tim1.login({
    //         userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //         userSig: userSig,
    //       });
    //       promise
    //           .then(function (imResponse) {
    //             let IM_userInfo = {
    //               userID: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
    //               userSig: userSig,
    //             };
    //             localStorage.setItem("IM_userInfo", JSON.stringify(IM_userInfo));
    //             let userID = JSON.parse(sessionStorage.getItem("loginInfo")).doc.id;
    //             _this.trtcCalling.login({userID, userSig});
    //             _this.showBox(p);
    //           })
    //           .catch(function (imError) {
    //             console.warn("login error:", imError); // 登录失败的相关信息
    //           });
    //     }
    //   });
    //   tim1.setLogLevel(1);
    // },
    // showBox(p) {
    //   let _this = this;
    //   MessageBox.confirm("是否确认接诊患者？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }).then(async () => {
    //     _this.patient = p;
    //     let options = {
    //       id: p.ddid,
    //       token: localStorage.getItem("token"),
    //       businessType: "BJJSHOS_DOC_OPEN_VIDEO_REMIND_TEMPLATE",
    //       pageMini: "pages/index/index",
    //     };
    //     let {code, obj} = await _this.$http(
    //         "smarthos.online.outpatient.intovideo",
    //         options
    //     );
    //     if (code == 0) {
    //       if (!obj.docAvatar) {
    //         _this.showcom = false;
    //         if (p.isAssAppointment == "1") {
    //           _this.$nextTick(() => {
    //             _this.toAccount = p.appointmentUserId;
    //             _this.showcom = true;
    //             console.log(_this.toAccount, '000')
    //           });

    //           return;
    //         } else {
    //           _this.$nextTick(() => {
    //             _this.toAccount = p.hzid;
    //             _this.showcom = true;
    //             console.log(_this.toAccount, '111')
    //           });
    //           return;
    //         }
    //       }
    //       let promise = _this.tim.updateMyProfile({
    //         nick:
    //             JSON.parse(sessionStorage.getItem("loginInfo")).doc.deptName +
    //             JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName +
    //             "医生",
    //         avatar: obj.docAvatar,
    //       });
    //       promise
    //           .then(function (imResponse) {
    //             _this.showcom = false;
    //             if (p.isAssAppointment == "1") {
    //               _this.$nextTick(() => {
    //                 _this.toAccount = p.appointmentUserId;
    //                 _this.showcom = true;
    //                 console.log(_this.toAccount, '333')
    //               });
    //             } else {
    //               _this.$nextTick(() => {
    //                 _this.toAccount = p.hzid;
    //                 _this.showcom = true;
    //                 console.log(_this.toAccount, '555')
    //               });
    //             }
    //           })
    //           .catch(function (imError) {
    //             console.warn("updateMyProfile error:", imError); // 更新资料失败的相关信息
    //           });
    //     }
    //   });
    // },
    async getDetail(p) {
      this.$store.state.patientData = p;
      this.$router.push({path: "/main/seeData"});
    },
    getAge(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      return year - idCardNum.substring(6, 10);
    },
    getSex(idCardNum) {
      if (!idCardNum) return;
      let date = new Date();
      let year = date.getFullYear();
      this.age = year - idCardNum.substring(6, 10);
      if (idCardNum.substring(16, 17) % 2 == 0) {
        return "女";
      } else return "男";
    },
    getAmpm(ampm) {
      if (ampm == "1") {
        return "上午";
      } else {
        return "下午";
      }
    },
    async remind(id) {
      let options = {
        id: id,
        token: localStorage.getItem("token"),
      };
      let {code} = await this.$http(
          "smarthos.online.outpatient.remind.customerservice",
          options
      );
      if (code === "0") this.$message.success("短信已发出");
    },
    async remindToWait1(id) {
      let options = {
        sendType: "TEXT",
        id: id,
        token: localStorage.getItem("token"),
      };
      let {code} = await this.$http("smarthos.online.outpatient.sms.push", options);
      if (code === "0") this.$message.success("短信提醒已发出");
    },
    async remindToWait(id) {
      let options = {
        sendType: "VOICE",
        id: id,
        token: localStorage.getItem("token"),
      };
      let {code} = await this.$http("smarthos.online.outpatient.sms.push", options);
      if (code === "0") this.$message.success("语言提醒已发出");
    },
    completeClinic() {
      MessageBox.confirm("确认结束问诊?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            let options = {
              id: this.ddId,
              token: tokenCache.get(),
            };
            let data = await this.$http("smarthos.online.outpatient.complete", options);
            if (data.code == 0) {
              Message({
                showClose: true,
                message: "门诊已结束",
                type: "success",
              });
              this.isInRoom = false;
              // this.$refs.wlmzVideo.leaveRoom();
              this.$emit(
                  "fresh",
                  timeStampFormat("yyyy-MM-dd"),
                  timeStampFormat("yyyy-MM-dd"),
                  "contentData1",
                  1
              );
            }
          })
          .catch(() => {
          });
    },
    prescribe() {
      MessageBox.confirm(
          "是否确定关闭视频，并跳转到开处方界面?（结束问诊前都可以再次进入视频间）",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "稍候再去",
            type: "warning",
          }
      )
          .then(() => {
            this.isInRoom = false;
            // this.$refs.wlmzVideo.leaveRoom();
            this.$emit(
                "fresh",
                timeStampFormat("yyyy-MM-dd"),
                timeStampFormat("yyyy-MM-dd"),
                "contentData1",
                1
            );
            this.$router.push({
              path: "/main/e-prescription",
              query: {ddId: this.ddId},
            });
          })
          .catch(() => {
          });
    },
    //填写诊疗记录
    showZljl() {
      this.$refs["jzjl"].show(this.patientInfo, this.ddxx);
      //  window.open('http://test-img-smarthos.hztywl.cn/RECIPE_201909_mQz5FX3_1gnVgd.pdf');
    },
    errTip() {
      Message({
        message: "该功能暂未开放",
        typr: "info",
        showClose: true,
      });
    },
    joinSuccess(param) {
      console.log(`====joinSuccess==param=======>`,param)
      this.isInRoom = true;
    },
    onUserJoinNotify(param) {
      console.log(`====onUserJoinNotify==param=======>`,param)
    },
  },
};
</script>
<style scoped>
button {
  height: 40px;
}

.show-img {
  width: 400px;
  height: 200px;
  border: 1px solid #123456;
}

.show-info {
  width: 400px;
  height: 200px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 95%;
  margin-left: 2.5%;
  margin-top: 20px;
}

.btn_blue {
  height: 25px!important;
  line-height: 20px!important;
  background-color: #07b3b3;
  color: #ffffff;
  padding: 2px 3px;
  border-radius: 4px;
  font-size: 14px;
}

.btn {
  height: 25px!important;
  line-height: 20px!important;
  background-color: #07b3b3;
  color: #ffffff;
  padding: 2px 3px;
  border-radius: 4px;
  font-size: 14px;
}

/*视频窗口*/
.video_box {
  width: 600px;
  height: 100%;
  border-radius: 15px;
  background: #fff;
}
.minimized-box{
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  color: #ffffff;
  font-size: 26px;
  background: #000000;
}

/*!* 强制覆盖子组件中的样式 *!*/
/*::v-deep .float-control-panel{*/
/*    position: absolute!important;*/
/*    right: 15px!important;*/
/*    top: 15px!important;*/
/*    width: 168px;*/
/*    height: 56px;*/
/*    background: white;*/
/*    z-index: 13;*/
/*    display: flex;*/
/*    flex-wrap: nowrap;*/
/*    justify-content: center;*/
/*    border-radius: 40px;*/
/*    box-shadow: #00000029 0 3px 6px, #0000003b 0 3px 6px;*/
/*}*/

.blank-default{
  display: flex;
  justify-content: center;
  align-items: end;
  color: #666;
}

.patient_group_line_r{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.switch-btn{
  margin-top: 15px;
  padding: 15px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #f2f2f2;
  text-align: center;
  color: #01abac;
  font-size: 14px;
}
</style>
